import { getJournalNumber } from '@debbie/common/dist/cases/index.js';
import { getJournalNumberToShowOnDebtorweb } from '@debbie/common/dist/journal-numbers/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
const BankTransfer = (props) => {
    const { paymentOption, collector, case: singleCase } = props;
    const customerLoader = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const tenant = useTenant();
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const lang = useSelector((s) => s.lang);
    const user = customer && me && customer.users.find((user) => user.userId === me.id);
    return (React.createElement("div", null,
        React.createElement("h2", null, lang.debtorWebHome.payWithBankTransfer),
        React.createElement("p", null, lang.debtorWebHome.payWithBankTransferText),
        React.createElement(Account, null,
            React.createElement("li", null, 
            // @ts-ignore
            paymentOption.details?.bankName),
            React.createElement("li", null,
                lang.debtorWebHome.registrationNumber,
                ' ',
                React.createElement("b", null, 
                // @ts-ignore
                paymentOption.details?.registrationNumber)),
            React.createElement("li", null,
                lang.debtorWebHome.accountNumber,
                ' ',
                React.createElement("b", null, 
                // @ts-ignore
                paymentOption.details?.accountNumber)),
            React.createElement(BoldText, null,
                "*",
                lang.debtorWebHome.payWithBankTransferInfo,
                ":",
                ' ',
                singleCase.customJournalNumber
                    ? getJournalNumber(singleCase.customJournalNumber, singleCase.id)
                    : getJournalNumberToShowOnDebtorweb(tenant, singleCase, user)))));
};
export default BankTransfer;
export const Account = styled.ul `
  padding-left: 0;

  li {
    list-style: none;
  }
`;
export const BoldText = styled.p `
  color: black;
  font-size: 0.8em;
  font-weight: bold;
  margin-top: 6px;
`;
//# sourceMappingURL=BankTransfer.js.map